import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IToDoDetailList, IToDoInitialState } from "./toDoModel";
import {
  ActiveInactiveToDo,
  createToDo,
  deleteToDo,
  deleteToDoAttachment,
  getAllActiveToDo,
  getAllToDos,
  getToDoByID,
  insertToDoAttachment,
  updateTaskStatus,
  updateToDo,
} from "./services/toDo.services";

const initialState: IToDoInitialState = {
  loading: false,
  formLoading: false,
  attachementDeleteOpen: false,
  timeDialogOpen: false,
  toDoActiveIndex: 0,
  error: "",
  ToDoDetailList: {},
  ToDoID: null,
  ToDoGUID: "",
  AttachementID: null,
  ToDoDetail: {
    ID: null,
    TitleGUID: "",
    Title: "",
    Reminder: "",
    ReminderTime: "",
    Note: "",
    ToDoStatus: false,
    IsActive: false,
    ToDoAttachmentList: [],
  },
};

const toDoSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {
    clearToDoDetails: (state) => {
      state.ToDoDetail = initialState.ToDoDetail;
    },
    setToDoID: (state, action) => {
      state.ToDoID = action.payload;
    },
    clearToDoID: (state) => {
      state.ToDoID = initialState.ToDoID;
    },
    setToDoGUID: (state, action) => {
      state.ToDoGUID = action.payload;
    },
    clearToDoGUID: (state) => {
      state.ToDoGUID = initialState.ToDoGUID;
    },
    settoDoActiveIndex: (state, action) => {
      state.toDoActiveIndex = action.payload;
    },
    cleartoDoActiveIndex: (state) => {
      state.toDoActiveIndex = initialState.toDoActiveIndex;
    },
    openAttachementDeleteOpen: (state) => {
      state.attachementDeleteOpen = true;
    },
    closeAttachementDeleteOpen: (state) => {
      state.attachementDeleteOpen = false;
    },
    openTimeDialogOpen: (state) => {
      state.timeDialogOpen = true;
    },
    closeTimeDialogOpen: (state) => {
      state.timeDialogOpen = false;
    },
    setAttachementID: (state, action) => {
      state.AttachementID = action.payload;
    },
    clearAttachementID: (state) => {
      state.AttachementID = initialState.AttachementID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllToDos.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllToDos.fulfilled,
      (state, action: PayloadAction<IToDoDetailList>) => {
        state.loading = false;
        state.ToDoDetailList = action.payload;
      }
    );
    builder.addCase(getAllToDos.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ToDoDetailList = initialState.ToDoDetailList;
    });
    builder.addCase(createToDo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createToDo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createToDo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateToDo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateToDo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateToDo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteToDo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteToDo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteToDo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getToDoByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getToDoByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ToDoDetail = action.payload;
    });
    builder.addCase(getToDoByID.rejected, (state, action) => {
      state.loading = false;
      state.ToDoDetail = initialState.ToDoDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveToDo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveToDo.fulfilled,
      (state, action: PayloadAction<IToDoDetailList>) => {
        state.loading = false;
        state.ToDoDetailList = action.payload;
      }
    );
    builder.addCase(getAllActiveToDo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ToDoDetailList = initialState.ToDoDetailList;
    });
    builder.addCase(ActiveInactiveToDo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveToDo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveToDo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(insertToDoAttachment.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertToDoAttachment.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertToDoAttachment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteToDoAttachment.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteToDoAttachment.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteToDoAttachment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTaskStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateTaskStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateTaskStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearToDoDetails,
  clearToDoID,
  setToDoID,
  setToDoGUID,
  clearToDoGUID,
  setAttachementID,
  clearAttachementID,
  settoDoActiveIndex,
  cleartoDoActiveIndex,
  openAttachementDeleteOpen,
  closeAttachementDeleteOpen,
  openTimeDialogOpen,
  closeTimeDialogOpen,
} = toDoSlice.actions;
export default toDoSlice.reducer;
